import React, { Component } from "react";
import ContentLoader from "react-content-loader";

// конструктор http://danilowoz.com/create-content-loader/

export class BreadcrumbsTitlePlaceholder extends Component {
  render() {
    return (
      <ContentLoader
        speed={2}
        width={400}
        height={80}
        viewBox="0 0 400 80"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
      >
        <rect x="0" y="0" rx="3" ry="3" width="67" height="14" />
        <rect x="0" y="0" rx="3" ry="3" width="11" height="11" />
        <rect x="0" y="35" rx="0" ry="0" width="400" height="40" />
      </ContentLoader>
    );
  }
}

export class MediaPlaceholder extends Component {
  render() {
    return (
      <div><ContentLoader
        speed={2}
        width={400}
        height={80}
        viewBox="0 0 400 80"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
      >
        <rect x="65" y="8" rx="3" ry="3" width="400" height="6" />
        <rect x="65" y="26" rx="3" ry="3" width="400" height="6" />
        <rect x="0" y="0" rx="3" ry="3" width="60" height="60" />
        <rect x="65" y="44" rx="3" ry="3" width="400" height="6" />
      </ContentLoader></div>
    );
  }
}

export const Placeholder = () => (
  <ContentLoader
    speed={2}
    width={400}
    height={160}
    viewBox="0 0 400 50"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    <rect x="0" y="0" rx="3" ry="3" width="67" height="11" />
    <rect x="76" y="0" rx="3" ry="3" width="140" height="11" />
    <rect x="0" y="23" rx="3" ry="3" width="140" height="11" />
    <rect x="148" y="23" rx="3" ry="3" width="173" height="11" />
  </ContentLoader>
)

export const ThreeDots = props => (
  <ContentLoader
    viewBox="0 0 400 160"
    height={160}
    width={400}
    speed={2}
    backgroundColor="transparent"
    {...props}
  >
    <circle cx="150" cy="86" r="8" />
    <circle cx="194" cy="86" r="8" />
    <circle cx="238" cy="86" r="8" />
  </ContentLoader>
)

ThreeDots.metadata = {
  name: 'RioF',
  github: 'clariokids',
  description: 'Three Dots',
  filename: 'ThreeDots',
}